import React, { useState, useEffect } from "react";
import "./Team.css";
import { SectionWrapper } from "../../hoc";
import { GridLoader } from "react-spinners"; // Import the spinner component from react-spinners
import TEAMPP from "./Team_personal_page";
import TEAMGP from "./Team_group_page";
import TEAMSP from "./Team_supervisors_page";
import { scrollToId } from "../../utils/scrollToId";

const Team = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  return (
    <div className="relative">
      {loading ? (
        <div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <GridLoader color="#BA55D3" loading={loading} />
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>
      ) : <script>{document.body.style.overflow = 'auto'}</script>}
        <>
          <div className="top-page">
            <h1> Team </h1>
          </div>
          <div
            className="grid grid-cols-12 mb-20"
            style={{ marginRight: "1rem", marginLeft: "3rem" }}
          >
            <main className="prose col-span-12 order-1">
              <div className="text_team">
                <h2>48C TEAM </h2>
                <hr className="dividergeneral mb-5" />
                <p className="mb-20">
                  Our dynamic team is composed of 12 students persuing
                  Bachelor’s or Master’s degree, with diverse backgrounds
                  spanning from Life Sciences to Computer Sciences, and even
                  extending to Microtechnics and Mechanics.
                </p>
              </div>
              <div className="mb-20">
                <TEAMPP />
              </div>
              <div className="mb-20">
                <TEAMSP />
              </div>
              <div className="mb-10">
                <TEAMGP />
              </div>
            </main>
          </div>
        </>
    </div>
  );
};

export default SectionWrapper(Team, "Team");
